import type { IMessage, InputToolbarProps } from 'react-native-gifted-chat';

import { StyleSheet } from 'react-native';

import { getColorTokenValue } from '@utility-nyc/react-native-ui-config';
import { InputToolbar } from 'react-native-gifted-chat';
import { useMedia } from 'tamagui';

import { getSizeTokenValue } from '@south-street-app/theme';

const styles = StyleSheet.create({
  inputPrimaryStyle: {
    borderColor: getColorTokenValue('$mono300'),
    borderWidth: 1,
    borderRadius: 12,
    minHeight: getSizeTokenValue('$14'),
    justifyContent: 'center',
    alignItems: 'center',
  },
  inputContainerStyle: {
    padding: getSizeTokenValue('$1'),
    borderTopWidth: 0,
  },
  inputContainerStyleDesktop: {
    padding: getSizeTokenValue('$4'),
    borderTopWidth: 0,
    justifyContent: 'center',
  },
});

const ChatInput = (props: InputToolbarProps<IMessage>) => {
  const { desktop } = useMedia();

  return (
    <InputToolbar
      {...props}
      primaryStyle={styles.inputPrimaryStyle}
      containerStyle={
        desktop ? styles.inputContainerStyleDesktop : styles.inputContainerStyle
      }
    />
  );
};

export { ChatInput };
